(ns practitest.frontend.age-chart
  (:require [practitest.frontend.common.utils :as utils]
            [practitest.frontend.init :as init]
            [practitest.frontend.components2.dashboard.chart :refer [chart]]))

(defn root-view [{:keys [data-item-id data-edit-url]}]
  [chart #:chart{:id       (parse-long data-item-id)
                 :edit-url data-edit-url}])

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "age-chart-component" root-view))

(utils/register-webcomponent! "age-chart-component")
